// Configuración por entorno. Cada valor sale de una variable REACT_APP_* (CRA la incrusta al compilar)
// y, si no está definida o viene vacía, usa el valor de producción, así un build sin variables nuevas
// queda igual que antes.

const env = (name, fallback) => process.env[name] || fallback;

export const firebaseConfig = {
    apiKey: env("REACT_APP_FIREBASE_API_KEY", "AIzaSyDujk75rooDjibC2AGtx6WfT8u6yXOVLI8"),
    authDomain: env("REACT_APP_FIREBASE_AUTH_DOMAIN", "muy-coach.firebaseapp.com"),
    projectId: env("REACT_APP_FIREBASE_PROJECT_ID", "muy-coach"),
    storageBucket: env("REACT_APP_FIREBASE_STORAGE_BUCKET", "muy-coach.appspot.com"),
    messagingSenderId: env("REACT_APP_FIREBASE_MESSAGING_SENDER_ID", "1099024667628"),
    appId: env("REACT_APP_FIREBASE_APP_ID", "1:1099024667628:web:c97be038069d4eadc4e6c9"),
    measurementId: env("REACT_APP_FIREBASE_MEASUREMENT_ID", "G-8TNQDCSXCR"),
};

export const paypalClientId = env(
    "REACT_APP_PAYPAL_CLIENT_ID",
    "AbFlsFVD3Ck8tyrBQmAMG24Op-XcgCNza1rWi32AVsNmx5ILuY8XeIoz33F9qguckU_pPSP7S6GRT7K2"
);

// Planes de PayPal (catálogo legado). Tienen que existir en la app de PayPal del client-id de arriba.
export const paypalPlanIds = {
    ACTIVE_MONTHLY: env("REACT_APP_PAYPAL_PLAN_ACTIVE_MONTHLY", "P-1XY44688JS183061BNFIQCPA"),
    PRO_MONTHLY: env("REACT_APP_PAYPAL_PLAN_PRO_MONTHLY", "P-3YX37151LT384051RNFIQCPI"),
    PREMIUM_MONTHLY: env("REACT_APP_PAYPAL_PLAN_PREMIUM_MONTHLY", "P-4TE93145XU398574CNFIQCPI"),
    ACTIVE_ANNUAL: env("REACT_APP_PAYPAL_PLAN_ACTIVE_ANNUAL", "P-1WM46421HB633861MNFIQCPQ"),
    PRO_ANNUAL: env("REACT_APP_PAYPAL_PLAN_PRO_ANNUAL", "P-25129416XD5822500NFIQCPQ"),
    PREMIUM_ANNUAL: env("REACT_APP_PAYPAL_PLAN_PREMIUM_ANNUAL", "P-9KN76790TG5718331NFIQCPQ"),
};
